<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">
                <!-- <img src="../../../assets/images/service/reumatologie-1.jpeg" alt="Reumatologie" /> -->

                <h2>Reumatologie – mobilitate și sănătatea articulațiilor tale</h2>
                <p>
                  Reumatologia se ocupă cu diagnosticarea și tratarea bolilor articulare, 
                  musculare și ale țesutului conjunctiv. Consultațiile sunt axate pe 
                  reducerea durerii, stoparea evoluției afecțiunilor inflamatorii sau degenerative 
                  și recăpătarea mobilității.
                </p>

                <!-- <h2>Echipa medicală</h2> -->
                <div class="row">
                  <div class="col-xl-3 col-lg-4 col-md-6 aos-init aos-animate" data-aos="fade-up"
                    data-aos-duration="1200" data-aos-delay="500">
                    <a href="/echipa_medicala/alexandra_veronica_mengheres#echipa_medicala">
                      <div class="team-card style1">
                        <div class="team-img"><img src="../../../assets/images/doctors/dr-alexandra-veronica-mengheres.jpg"
                            alt="dr-alexandra-veronica-mengheres"></div>
                        <div class="team-info">
                          <span>Dr. Alexandra Veronica Menghereș </span> 
                          <!-- <span>Medic specialist reumatolog</span> -->
                        </div>
                      </div>
                    </a>
                  </div>
                </div>

                <h3>Servicii</h3>
                <p>
                  În cadrul cabinetului de reumatologie sunt oferite evaluări complete 
                  pentru diagnosticarea și tratarea durerilor articulare și a bolilor reumatice.
                </p>

                <div class="card mb-10" v-for="service in services" :key="service.name">
                  <div class="row" style="padding: 10px 20px;">
                    <div class="card-service col-xl-10 col-lg-10 col-md-10">
                      <i class="ri-check-double-line" style="vertical-align: bottom;"></i> {{ service.name }}
                    </div>
                    <div class="service-price col-xl-2 col-lg-2 col-md-2 text-align-right">
                      <!-- {{ service.price }} Lei -->
                    </div>
                  </div>
                </div>

                <div class="other-option md-none mb-40">
                  <a href="/#appointment" class="btn style2">
                    Solicită o programare
                  </a>
                </div>

                <h3>Întrebări frecvente</h3>
                <p>
                  Mai jos găsești răspunsuri la cele mai frecvente întrebări legate de 
                  consultațiile de reumatologie.
                </p>

                <div class="accordion" id="accordionExample_one">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Când este recomandat să mergi la o consultație de reumatologie?
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          O consultație este recomandată dacă te confrunți cu dureri articulare persistente, 
                          Umflături, rigiditate articulară dimineața (care durează mai mult de 30 de minute) 
                          sau dureri de spate fără o cauză clară.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Care este diferența dintre ortopedie și reumatologie?
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Reumatologul tratează afecțiunile articulare și autoimune prin metode non-chirurgicale 
                          și medicamentoase, în timp ce ortopedul se ocupă cu intervențiile chirurgicale, 
                          traumatologia și leziunile mecanice (fracturi, entorse).
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Ce investigații trebuie să aduc la prima consultație?
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Este util să aduci analize de sânge recente, radiografii, RMN sau ecografii 
                          articulare efectuate anterior. În caz contrar, medicul reumatolog va solicita 
                          investigațiile specifice în urma consultației.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Bolile reumatice pot fi vindecate complet?
                      </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Multe boli reumatice sunt afecțiuni cronice, dar depistate timpuriu și gestionate corect 
                          prin tratamente moderne, acestea pot fi trecute în remisiune completă, permițând o viață 
                          fără durere și fără limitări de mobilitate.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "ReumatologiePage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
      services: [
        {
          name: "Consultație reumatologică",
          price: 300
        },
        {
          name: "Control și monitorizare afecțiuni reumatice",
          price: 200
        },
        {
          name: "Interpretare analize de laborator și imagistică",
          price: 150
        },
        {
          name: "Infiltrație intraarticulară (manoperă)",
          price: 250
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>